const rpArgsMc = (contrato, numeroRC, totRecibido, userLogin, descrRecurso, numeroDocumUA, saldoCl, fechaHoraHoy) => {
  // let fechaHoy = new Date()
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)

  let creaColecc = []
  let argsAdd = {}
  argsAdd['contrato'] = contrato
  argsAdd['fechaMov'] = fechaHoy
  argsAdd['tipo'] = "D"
  argsAdd['subTipo'] = "PO"
  argsAdd['procesado'] = "S"
  if(descrRecurso!==""){
    argsAdd['origen'] = "Pago en tercero"
    argsAdd['codigoServicio'] = numeroDocumUA
    argsAdd['nombreResumido'] = descrRecurso
    argsAdd['descripcionServicio'] = descrRecurso
    argsAdd['descrClaseServ'] = descrRecurso
    argsAdd['concepto'] = descrRecurso
  }else{
    argsAdd['origen'] = "Pago en oficina"
  }
  argsAdd['saldoCliente'] = saldoCl
  argsAdd['valorTotal'] = totRecibido
  argsAdd['valorAntesImptos'] = totRecibido
  argsAdd['numeroRC'] = numeroRC
  argsAdd['documento'] = numeroRC
  argsAdd['valorPagado'] = totRecibido
  argsAdd['fechaUltPago'] = fechaHoy
  argsAdd['valorUltPago'] = totRecibido
  argsAdd['usuarioCreate'] = userLogin
  argsAdd['fechaCreate'] = fechaHoraHoy
  creaColecc.push(argsAdd)
// console.log(argsAdd)
  let colecc = {creaColecc}

  return colecc
}

export default rpArgsMc
  